import { render, staticRenderFns } from "./ProductSearch.vue?vue&type=template&id=6f87cfa1&scoped=true&"
import script from "./ProductSearch.vue?vue&type=script&lang=js&"
export * from "./ProductSearch.vue?vue&type=script&lang=js&"
import style0 from "./ProductSearch.vue?vue&type=style&index=0&id=6f87cfa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f87cfa1",
  null
  
)

export default component.exports